export class Click {
    id_action:number=0;
    other_information:string='';
}
